import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function CategoryNav() {
  const categoryIcons: Record<string, string> = {
    all: 'ri-apps-line',
    anime: 'ri-movie-line',
    movie: 'ri-film-line',
    ova: 'ri-disc-line',
    music: 'ri-music-line',
    news: 'ri-newspaper-line',
    character: 'ri-user-smile-line',
  };

  return (
    <section className="bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6 py-10 md:py-14">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            浏览分类
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            按内容类型快速查找你想看的凪光系列作品
          </p>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={cat.slug === 'all' ? '/' : `/category/${cat.slug}`}
              className="whitespace-nowrap flex items-center gap-2 px-5 py-2.5 rounded-full bg-background-100 hover:bg-primary-50 text-foreground-700 hover:text-primary-600 border border-background-200 hover:border-primary-200 transition-all cursor-pointer text-sm font-medium"
            >
              <i className={`${categoryIcons[cat.slug] || 'ri-folder-line'} text-base`}></i>
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}